var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFolder = function SvgFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#0C141B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M6.42 34.848V9.17a3.667 3.667 0 0 1 3.668-3.668H33.93a3.667 3.667 0 0 1 3.668 3.668v18.341a3.667 3.667 0 0 1-3.668 3.668H10.088a3.667 3.667 0 0 0-3.669 3.668 3.667 3.667 0 0 0 3.669 3.669H33.93a3.667 3.667 0 0 0 3.668-3.669v-9.17M30.263 14.044H13.756M30.263 22.009H13.756"
  })));
};
export { SvgFolder as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiMjQ5ZjQwMWNmM2IzNzFhYzI4OWJkMDFhMmJkMTk2OGMuc3ZnIjs=";